/** @jsxImportSource @emotion/react */

import { FC, ReactNode } from "react";

import {
  CSSRulesResolver,
  useCSSRulesWithTheme,
} from "hooks/useCSSRulesWithTheme";
import { Typography } from "@a_team/ui-components";

const getCSSRules: CSSRulesResolver = () => ({
  container: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    marginTop: 36,
    maxWidth: 680,
    padding: "0 40px",
    gap: 16,
    width: "100%",

    "p, span": {
      fontSize: 14,
      lineHeight: "20px",
      marginBottom: 0,
      marginTop: 0,
    },

    "@media (max-width: 600px)": {
      padding: "0 16px",
    },
  },
  heading: {
    fontWeight: 800,
    fontSize: 24,
    lineHeight: "28.8px",
    letterSpacing: -1,
  },
});

const Section: FC<{
  name?: string | ReactNode;
  children: ReactNode;
  className?: string;
}> = ({ name, children, className }) => {
  const styles = useCSSRulesWithTheme(getCSSRules);

  return (
    <div css={styles.container} className={className}>
      {name && (
        <Typography
          variant="textLarge"
          component={"h2"}
          weight="bold"
          css={styles.heading}
        >
          {name}
        </Typography>
      )}
      {children}
    </div>
  );
};

export default Section;
